var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-5",attrs:{"headers":_vm.headers,"items":_vm.products,"loading":_vm.loading,"options":_vm.options,"server-items-length":_vm.previewCount,"footer-props":{
    'items-per-page-options': []
  },"fixed-header":true,"height":"400"},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:`item.sourceTags`,fn:function({ item }){return [_vm._v(" "+_vm._s(item.sourceTags ? item.sourceTags.join(', ') : '')+" ")]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }